import React, { useEffect, useState } from 'react';
import { Loader2, Compass, Target, Building2, ShieldAlert, TrendingUp, ListChecks, MessageCircle, MapPin } from 'lucide-react';
import { clientApi } from '../../components/client-portal/clientPortalApi';

const SECTIONS = [
  { key: 'client_goals',           title: 'Your goals',                icon: Target },
  { key: 'current_situation',      title: 'Where you are now',         icon: MapPin },
  { key: 'recommended_structure',  title: 'Recommended structure',     icon: Compass },
  { key: 'why_lender_selected',    title: 'Why this lender',           icon: Building2 },
  { key: 'risks_considerations',   title: 'Risks & considerations',    icon: ShieldAlert },
  { key: 'long_term_plan',         title: 'Long-term plan',            icon: TrendingUp },
  { key: 'next_steps',             title: 'Next steps',                icon: ListChecks },
  { key: 'broker_notes',           title: 'A note from your broker',   icon: MessageCircle },
];

export default function ClientStrategy() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try { setData(await clientApi('/client/strategy')); }
      finally { setLoading(false); }
    })();
  }, []);

  if (loading) return <div className="flex justify-center py-24"><Loader2 className="w-6 h-6 animate-spin text-slate-400" /></div>;

  const published = !!data?.published;

  return (
    <div className="space-y-6" data-testid="client-strategy">
      <div>
        <h1 className="text-2xl sm:text-3xl font-semibold text-slate-900">Your loan strategy</h1>
        <p className="text-slate-500 mt-1 text-sm">The thinking behind your recommendation — not just the loan, but the strategy.</p>
      </div>

      {!published && (
        <div className="rounded-2xl bg-white ring-1 ring-slate-200 p-10 text-center text-slate-500">
          <Compass className="w-10 h-10 mx-auto text-slate-300" />
          <div className="mt-3 text-sm">Your broker is preparing your strategy. We'll let you know as soon as it's ready.</div>
        </div>
      )}

      {published && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {SECTIONS.map(({ key, title, icon: Icon }) => {
            const value = (data || {})[key];
            if (!value) return null;
            return (
              <section key={key} className="rounded-2xl bg-white ring-1 ring-slate-200 p-5" data-testid={`strategy-${key}`}>
                <div className="flex items-center gap-2 text-emerald-700 text-xs font-semibold uppercase tracking-wide">
                  <Icon className="w-3.5 h-3.5" />
                  {title}
                </div>
                <div className="mt-2 text-sm text-slate-700 whitespace-pre-wrap leading-relaxed">{value}</div>
              </section>
            );
          })}
        </div>
      )}
    </div>
  );
}
